// extracted by mini-css-extract-plugin
export default {"empty-overlay":"H5rcbaCfm5p3edaVcSpy","kitchen-table":"ZEqtvBIs7pMQEZCC0xhw"};